/* SHANTAM global.js — drawers, ajax cart, reveals, product UX */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = document.body.getAttribute('data-money-format') || '₹{{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  /* ---------- Drawers ---------- */
  function openDrawer(name) {
    document.body.classList.add('drawer-open--' + name);
    var d = document.querySelector('[data-drawer="' + name + '"]');
    if (d) {
      var f = d.querySelector('button, a, input');
      if (f) f.focus({ preventScroll: true });
    }
  }
  function closeDrawers() {
    document.body.classList.remove('drawer-open--nav', 'drawer-open--cart');
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer-overlay')) {
      closeDrawers();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    }, { passive: true });
  }

  /* ---------- Scroll reveal ---------- */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- AJAX Cart ---------- */
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    var body = document.querySelector('[data-cart-drawer-body]');
    var foot = document.querySelector('[data-cart-drawer-foot]');
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><p>' + (body.getAttribute('data-empty-text') || 'Your cart is empty. Take a breath — then explore the collection.') + '</p><a class="btn btn--ghost" href="/collections/all">' + (body.getAttribute('data-empty-cta') || 'Shop the collection') + '</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;

    var html = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_180x$1$2') : '';
      return '<div class="cart-line" data-line-key="' + item.key + '">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy" width="82" height="102">' : '<span></span>') +
        '<div><div class="cart-line__title">' + item.product_title + '</div>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line__meta">' + item.variant_title + '</div>' : '') +
        '<div class="cart-line__meta">' + money(item.final_line_price) + '</div>' +
        '<div style="display:flex;gap:14px;align-items:center;margin-top:10px">' +
          '<span class="qty"><button type="button" data-qty-change="-1" aria-label="Decrease quantity">−</button>' +
          '<input type="number" value="' + item.quantity + '" min="0" data-qty-input aria-label="Quantity">' +
          '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button></span>' +
          '<button type="button" class="cart-remove" data-line-remove>Remove</button>' +
        '</div></div></div>';
    }).join('');
    body.innerHTML = html;

    var subtotal = document.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.items_subtotal_price);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var line = e.target.closest('.cart-line');
    if (!line || !line.closest('[data-drawer="cart"]')) return;
    var key = line.getAttribute('data-line-key');
    var input = line.querySelector('[data-qty-input]');
    if (e.target.closest('[data-qty-change]')) {
      var delta = parseInt(e.target.closest('[data-qty-change]').getAttribute('data-qty-change'), 10);
      changeLine(key, Math.max(0, (parseInt(input.value, 10) || 0) + delta));
    }
    if (e.target.closest('[data-line-remove]')) changeLine(key, 0);
  });

  /* Add-to-cart forms (product page + cards) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-adding-text') || 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return fetchCart(); })
      .then(function () {
        openDrawer('cart');
        if (btn) { btn.textContent = btn.getAttribute('data-added-text') || 'Added ✓'; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1400); }
      })
      .catch(function (err) {
        if (btn) { btn.textContent = (err && err.description) ? 'Unavailable' : 'Try again'; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800); }
      });
  });

  fetchCart();

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery.querySelector('[data-gallery-main]');
    main.src = thumb.getAttribute('data-thumb');
    if (thumb.getAttribute('data-thumb-srcset')) main.srcset = thumb.getAttribute('data-thumb-srcset');
    gallery.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---------- Variant selection ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (wrap) {
    var json = wrap.querySelector('[data-product-json]');
    if (!json) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (err) { return; }
    var idInput = wrap.querySelector('input[name="id"]');
    var priceEl = wrap.querySelector('[data-price]');
    var btn = wrap.querySelector('[data-add-btn]');

    function currentOptions() {
      var opts = [];
      wrap.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }
    function update() {
      var opts = currentOptions();
      var match = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = money(match.price) + (match.compare_at_price > match.price ? ' <s class="price--compare">' + money(match.compare_at_price) + '</s>' : '');
      }
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? (btn.getAttribute('data-default-text') || 'Add to cart') : (btn.getAttribute('data-soldout-text') || 'Sold out');
      }
    }
    wrap.addEventListener('change', function (e) { if (e.target.matches('[data-option-index] input')) update(); });
    update();
  });
})();

/* ============================================================
   V2 — SANCTUM interactions
   ============================================================ */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Breath progress line */
  var line = document.querySelector('.breath-line');
  if (line) {
    var onScroll = function () {
      var h = document.documentElement;
      var p = h.scrollTop / (h.scrollHeight - h.clientHeight || 1);
      line.style.transform = 'scaleX(' + p + ')';
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* Guided-breath entry veil (once per session) */
  var veil = document.querySelector('.breath-veil');
  if (veil) {
    var seen = false;
    try { seen = sessionStorage.getItem('shantam-breathed') === '1'; } catch (e) {}
    var finish = function () {
      veil.classList.add('is-done');
      try { sessionStorage.setItem('shantam-breathed', '1'); } catch (e) {}
      document.querySelectorAll('.hero2').forEach(function (h) { h.classList.add('is-in'); });
      setTimeout(function () { veil.remove(); }, 1600);
    };
    if (seen || reduced) {
      veil.remove();
      document.querySelectorAll('.hero2').forEach(function (h) { h.classList.add('is-in'); });
    } else {
      var word = veil.querySelector('.veil-word');
      veil.querySelector('.veil-skip').addEventListener('click', finish);
      setTimeout(function () { veil.classList.add('phase-in'); word.textContent = word.dataset.in; }, 300);
      setTimeout(function () { veil.classList.remove('phase-in'); veil.classList.add('phase-out'); word.textContent = word.dataset.out; }, 4300);
      setTimeout(finish, 8500);
    }
  } else {
    document.querySelectorAll('.hero2').forEach(function (h) {
      requestAnimationFrame(function () { h.classList.add('is-in'); });
    });
  }

  /* Calm cursor */
  if (fine && !reduced) {
    document.body.classList.add('has-cursor');
    var dot = document.createElement('div'); dot.className = 'cursor-dot';
    var halo = document.createElement('div'); halo.className = 'cursor-halo';
    document.body.append(dot, halo);
    var mx = innerWidth / 2, my = innerHeight / 2, hx = mx, hy = my;
    addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; dot.style.left = mx + 'px'; dot.style.top = my + 'px'; });
    (function loop() { hx += (mx - hx) * 0.14; hy += (my - hy) * 0.14; halo.style.left = hx + 'px'; halo.style.top = hy + 'px'; requestAnimationFrame(loop); })();
    document.addEventListener('mouseover', function (e) { if (e.target.closest('a,button,summary,input,[data-tilt]')) halo.classList.add('is-active'); });
    document.addEventListener('mouseout', function (e) { if (e.target.closest('a,button,summary,input,[data-tilt]')) halo.classList.remove('is-active'); });
    document.addEventListener('mousedown', function (e) {
      var r = document.createElement('div'); r.className = 'cursor-ripple';
      r.style.left = e.clientX + 'px'; r.style.top = e.clientY + 'px';
      document.body.appendChild(r); setTimeout(function () { r.remove(); }, 850);
    });
  }

  /* Magnetic buttons */
  if (fine && !reduced) {
    document.querySelectorAll('.btn').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * 0.18 + 'px,' + (e.clientY - r.top - r.height / 2) * 0.28 + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* 3D tilt cards */
  if (fine && !reduced) {
    document.querySelectorAll('[data-tilt]').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.style.transform = 'perspective(900px) rotateY(' + (x - 0.5) * 7 + 'deg) rotateX(' + (0.5 - y) * 7 + 'deg)';
        card.style.setProperty('--gx', x * 100 + '%'); card.style.setProperty('--gy', y * 100 + '%');
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  /* Stat counters */
  var counters = document.querySelectorAll('[data-count]');
  if (counters.length) {
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return; cio.unobserve(en.target);
        var el = en.target, end = parseFloat(el.dataset.count), t0 = null;
        var step = function (t) {
          if (!t0) t0 = t; var p = Math.min((t - t0) / 1400, 1);
          el.firstChild.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    counters.forEach(function (c) { cio.observe(c); });
  }

  /* Breath Lab — guided cycle: inhale 4 · hold 2 · exhale 6, x3 */
  var lab = document.querySelector('.lab-orb-wrap');
  if (lab) {
    var orb = lab.querySelector('.lab-orb');
    var phase = lab.querySelector('.lab__phase');
    var dots = lab.querySelectorAll('.lab__count i');
    var running = false;
    var idle = phase.dataset.idle;
    phase.textContent = idle;
    orb.addEventListener('click', function () {
      if (running) return; running = true;
      lab.classList.add('is-running');
      dots.forEach(function (d) { d.classList.remove('is-done'); });
      var cycle = 0;
      var doCycle = function () {
        lab.classList.remove('phase-exhale'); lab.classList.add('phase-inhale');
        phase.textContent = phase.dataset.in;
        setTimeout(function () {
          lab.classList.remove('phase-inhale'); lab.classList.add('phase-hold');
          phase.textContent = phase.dataset.hold;
          setTimeout(function () {
            lab.classList.remove('phase-hold'); lab.classList.add('phase-exhale');
            phase.textContent = phase.dataset.out;
            setTimeout(function () {
              if (dots[cycle]) dots[cycle].classList.add('is-done');
              cycle++;
              if (cycle < 3) { doCycle(); }
              else {
                lab.classList.remove('is-running', 'phase-exhale');
                phase.textContent = phase.dataset.done || idle;
                running = false;
                setTimeout(function () { phase.textContent = idle; }, 4000);
              }
            }, 6000);
          }, 2000);
        }, 4000);
      };
      doCycle();
    });
  }
})();
